<template>

  <div>
    <div class="card">
      <div class="p-3">
        <div
          v-if="permissions.includes('manage_settings') && dashcomponent.fixed === false"
          class="btn-group"
          style="float: right;">
          <button
            type="button"
            class="btn btn-sm btn-light dropdown-toggle dropdown-toggle-split"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <div
            class="dropdown-menu dropdown-menu-right">
            <button
              class="dropdown-item"
              @click="changeSize(3)">{{ $t('Width') }} 25%</button>
            <button
              class="dropdown-item"
              @click="changeSize(6)">{{ $t('Width') }} 50%</button>
            <button
              class="dropdown-item"
              @click="changeSize(9)">{{ $t('Width') }} 75%</button>
            <button
              class="dropdown-item"
              @click="changeSize(12)">{{ $t('Width') }} 100%</button>
            <button
              class="dropdown-item"
              @click="showEditModal()">{{ $t('Edit') }}</button>
            <button
              class="dropdown-item"
              @click="deleteDashcomponent()">{{ $t('Delete') }}</button>
          </div>
        </div>
        <span
          v-if="dashcomponent.fixed === false"
          class="sortable-move text-secondary">
          <i class="fas fa-arrows-alt" />
          </span>
        <strong>{{ dashcomponent.name }}</strong>
      </div>
      <div class="card-body">
        <ReportChart
          :dashcomponent="dashcomponent" />
      </div>
    </div>
    <DashcomponentForm
      v-if="modal_select"
      :initDashcomponent="modal_select" 
      @hideModal="hideModal()"
      @deleted="hideModal()" 
      @saved="hideModal()" />
  </div>

</template>

<script>
import DashcomponentForm from './DashcomponentForm'
import ReportChart from './ReportChart/index'

export default {
  name: 'DashcomponentMosaicItem',
  components: {
    ReportChart,
    DashcomponentForm
  },
  props: {
    dashcomponent: {
      type: Object
    },
    dashboardId: {
      type: String
    }
  },
  data () {
    return {
      modal_select: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    }
  },
  created () {
  },
  methods: {
    /*
    modal
    */
    showEditModal () {
      this.modal_select = this.dashcomponent
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    changeSize
    */
    changeSize (num) {
      this.$store
      .dispatch('updateDashcomponent', {
        _id: this.dashboardId,
        width_num: num
      })
    },
    /*
    delete
    */
    deleteDashcomponent () {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteDashcomponent', {
          dashboard_id: this.dashboardId,
          id: this.dashcomponent._id
        })
        .then((result) => {
          this.loading = false
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/DashcomponentMosaicItem.vue